import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorDialogContext, errorHandledAsync, errorHandledSync, } from "@/shared/context/error-context";
import { DeleteUserService } from "@/features/user/services/delete-user-service";
import { useDeleteUserStates } from "@/features/user/hooks/use-delete-user-states";
//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { EndpointPathNames } from "@/shared/config/endpoint-path";


export const useDeleteUser = () => {
  const deleteUserService = new DeleteUserService();
  const navigate = useNavigate();

  const {
    check,
    setCheck,
    isActiveDeleteButton, // 削除ボタンの有効フラグ
    setIsActiveDeleteButton,
    isShowErrorDialog, // エラーダイアログ表示フラグ情報
    setIsShowErrorDialog,
  } = useDeleteUserStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const onChangeDeleteButtonState = (checked: boolean) => {
    setIsActiveDeleteButton(checked);
  }

  // 「削除」押下時のコールバック
  const onClickDelete = async () => {
    loadingCtx.setIsLoading(true);

    try {
      await deleteUserService.deleteUser({});
      // 削除成功
      navigateLogin();
    } catch (error) {
      console.log(error);  // 開発用対応
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // ログイン画面へ遷移
  const navigateLogin = () => {
    // ブラウザバックで戻れないよう履歴を置換する
    navigate(EndpointPathNames.LOGIN, { replace: true });
  };

    const onTapCheckBox = () => {
    if (check) {
      setCheck(false);
    } else {
      setCheck(true);
    }
  };

  // エラーダイアログを閉じる
  const closeErrorDialog = () => {
    setIsShowErrorDialog({
      isError: false,
      errorMessage: "",
    });
  };

  return {
    check,
    setCheck,
    isActiveDeleteButton,
    isShowErrorDialog,
    onChangeDeleteButtonState: errorHandledSync(onChangeDeleteButtonState, setError),
    onTapCheckBox: errorHandledSync(onTapCheckBox, setError),
    onClickDelete: errorHandledAsync(onClickDelete, setError),
    closeErrorDialog: errorHandledSync(closeErrorDialog, setError),
  };
};
